<template>
    <svg
        class="kgr-icon"
        :class="computedIconClass"
        :title="title"
        @click="click"
        @mouseout="$emit('mouseout')"
    >
        <use v-bind="{'xlink:href': '/styleguide/icons.svg?v=' + cacheKey + '#' + iconClass }" />
        <circle v-if="greenDot && !small" cx="18" cy="18" r="5" fill="#4CAF50" stroke="white" stroke-width="1.5"/>
        <circle v-if="greenDot && small" cx="15" cy="15" r="5" fill="#4CAF50" stroke="white" stroke-width="1.5"/>
    </svg>
</template>

<script>
export default {
    props: {
        iconClass: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        small: {
            type: Boolean,
            required: false,
        },
        big: {
            type: Boolean,
            required: false,
        },
        tiny: {
            type: Boolean,
            required: false,
        },
        accent: {
            type: Boolean,
            required: false,
        },
        hoverAccent: {
            type: Boolean,
            required: false,
        },
        highlight: {
            type: Boolean,
            required: false,
        },
        light: {
            type: Boolean,
            required: false,
        },
        circle: {
            type: Boolean,
            required: false,
        },
        inverted: {
            type: Boolean,
            required: false,
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
        greenDot: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    computed: {
        computedIconClass() {
            return {
                'clickable': !this.disabled,
                'kgr-icon--light': this.disabled || this.light,
                'kgr-icon--accent': this.accent,
                'kgr-icon--hoverAccent': this.hoverAccent,
                'kgr-icon--highlight': this.highlight,
                'kgr-icon--small': this.small,
                'kgr-icon--big': this.big,
                'kgr-icon--tiny': this.tiny,
                'kgr-icon--circle': this.circle,
                'kgr-icon--inverted': this.inverted
            };
        },
        cacheKey() {
            return window?.kgr?.iconCacheKey ?? '';
        }
    },
    methods: {
        click() {
            if (!this.disabled) {
                this.$emit('click');
            }
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .clickable {
        cursor: pointer;
    }
</style>
